import { Action } from 'redux';
import { User, UserDIR, UserENT, UserPUB } from '../../../types/models/user/user.types';
import { Commercial } from '../../../types/api/endpoints/commercial/commercial.types';

export const SET_PROFILE = 'SET_PROFILE';
export const SIGN_OUT = 'SIGN_OUT';

export interface SetProfileAction extends Action {
  type: typeof SET_PROFILE;
  profile: User | UserPUB | UserENT | UserDIR | Commercial | null;
}

export interface SignOutAction extends Action {
  type: typeof SIGN_OUT;
}

type AuthenticationReducerActionsTypes = SetProfileAction | SignOutAction;

export default AuthenticationReducerActionsTypes;
